export class MailServiceArgs {
  public MailTo: string[];
  public MailCopy: string[];
  public Subject: string;
  public BodyContent: string;
  public Replacements?: Map<string, string>;
}

